export default "/images/vendor/flag-icon-css/flags/1x1/ug.svg?983dd591c56af488af9614a3b3fc9711";